import { render, staticRenderFns } from "./PiezoelectricEffectViz.vue?vue&type=template&id=2795b2f8&scoped=true"
import script from "./PiezoelectricEffectViz.vue?vue&type=script&lang=js"
export * from "./PiezoelectricEffectViz.vue?vue&type=script&lang=js"
import style0 from "./PiezoelectricEffectViz.vue?vue&type=style&index=0&id=2795b2f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2795b2f8",
  null
  
)

export default component.exports